import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import PhotographicRecordForm from '../Forms/PhotographicRecordForm';

const PhotographicRecordModal = ({
	dataPhotographicRecord,
	isOpen,
	isEdit,
	handleIsEdit,
	handleToggleModal,
	photographicRecordsList,
	handlePhotographicRecordsList,
	selectedSector,
	dataBeachCleaning
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='md'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Registro Fotográfico
			</ModalHeader>

			<PhotographicRecordForm
				dataPhotographicRecord={dataPhotographicRecord}
				isOpen={isOpen}
				isEdit={isEdit}
				handleIsEdit={handleIsEdit}
				handleToggleModal={handleToggleModal}
				photographicRecordsList={photographicRecordsList}
				handlePhotographicRecordsList={handlePhotographicRecordsList}
				selectedSector={selectedSector}
				dataBeachCleaning={dataBeachCleaning}
			/>
		</Modal>
	);
};

export default PhotographicRecordModal;